export const getJobWidgetsCommonListPrefix = (jobWidgetsId: string): string =>
  `admin_jobs_widgets_${jobWidgetsId}`;
